<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper">
      <div class="left">
        <div class="block">
          <AssembledPartInfoForm is-new></AssembledPartInfoForm>
        </div>
      </div>
      <div class="right">
        <div class="block">
          <h2>{{ $t('mechanical.image') }}</h2>
          <FileManagedSimpleUploader @on-success="handleFileUploaded" accept=".jpg, .jpeg, .png, .gif, .svg, .bmp" multiple drag-drop></FileManagedSimpleUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssembledPartInfoForm from './components/assembled-part-info-form'
import { FileManagedSimpleUploader } from '@/components/file'
export default {
  name: 'AssembledPartNew',
  components: {
    AssembledPartInfoForm,
    FileManagedSimpleUploader
  },
  computed: {
    pageTitle () {
      document.title = this.$t('assembled.new.title')
      return document.title
    }
  },
  methods: {
    handleFileUploaded () {}
  }
}
</script>
